export default {
    common: {
        cashReal: "Espèces réelles",
        cashExpected: "Espèces attendues",
        cardReal: "Soldes carte réelles",
        cardExpected: "Soldes carte attendues",
        done: "Terminé",
        duplicate: "Dupliquer",
        loading: "Chargement...",
        loadingProducts: "Chargement des produits...",
        loadingPostalCodes: "Chargement des codes postaux...",
        loadingRestaurantData: "Chargement des données des restaurants...",
        all: "Tous",
        save: "Enregistrer",
        saving: "Enregistrement en cours",
        cancel: "Annuler",
        delete: "Supprimer",
        deleting: "Suppression en cours",
        edit: "Modifier",
        add: "Ajouter",
        search: "Rechercher",
        filter: "Filtrer",
        reset: "Réinitialiser",
        confirm: "Confirmer",
        confirmation: "Confirmation",
        close: "Fermer",
        refresh: "Actualiser",
        back: "Retour",
        next: "Suivant",
        previous: "Précédent",
        first: "Première",
        last: "Dernière",
        submit: "Soumettre",
        yes: "Oui",
        no: "Non",
        actions: "Actions",
        status: "Statut",
        date: "Date",
        time: "Heure",
        minutes: "minutes",
        name: "Nom",
        description: "Description",
        price: "Prix",
        quantity: "Quantité",
        total: "Total",
        language: "Langue",
        customer: "Client",
        company: "Entreprise",
        view: "Voir",
        page: "Page",
        update: "Mettre à jour",
        paymentStatus: "Statut de paiement",
        more: "Plus",
        seeLess: "Voir moins",
        create: "Créer",
        title: "Titre",
        message: "Message",
        selectRestaurant: "Sélectionner un restaurant",
        chooseRestaurant: "Choisir un restaurant...",
    },
    header: {
        profile: "Mon compte",
        myRestaurant: "Mon restaurant",
        changePassword: "Modifier mot de passe",
        logout: "Déconnexion",
        administrator: "Administrateur",
        restaurant: "Restaurant",
    },
    roles: {
        administrator: "ADMINISTRATEUR",
        user: "UTILISATEUR",
        franchise: "FRANCHISE",
        restaurant: "RESTAURANT",
        technicalSupport: "SUPPORT TECHNIQUE",
        guest: "CLIENT",
    },
    sidebar: {
        dashboard: "Tableau de bord",
        pos: "POS",
        posSystem: "POS Système",
        sales: "Ventes",
        orders: "Commandes",
        transactions: "Transactions",
        salesReport: "Rapport de vente",
        management: "Gestion",
        timeSlots: "Créneaux",
        deliveryZones: "Zones de livraison",
        products: "Produits",
        categories: "Catégories",
        ingredients: "Ingrédients",
        ingredientTypes: "Types d'ingrédients",
        managmentCategories: "Gestion des catégories d'ingrédients",
        personalization: "Personnalisation",
        supplements: "Suppléments",
        supplementTypes: "Types de suppléments",
        features: "Options",
        ingredientBases: "Ingrédients de base",
        campaigns: "Campagnes",
        emailCampaigns: "Campagnes e-mail",
        pushNotifications: "Notifications push",
        programs: "Parrainage & Fidelité",
        customers: "Clients",
        users: "Utilisateurs",
        userList: "Liste des utilisateurs",
        restaurants: "Restaurants",
        restaurantList: "Liste des restaurants",
        franchises: "Franchises",
        accounts: "Comptes",
        coupon: "Coupon",
        openingHours: "Horaires d'ouverture",
        paymentMethods: "Moyens de paiement",
        applications: "Applications",
        omnesightAi: "Omnesight AI",
        logout: "Déconnexion",
        referral: "Programmes",
        loyalty: "Fidélité & Parrainage",
        automatedMessages: "Messages Automatiques",
        advancedAnalytics: "Analytique Avancée",
        closures: "Fermetures Exceptionnelles",
        marketing: "Marketing",
        marketingContent: "Contenu Public",
        customElements: "Personnalisation",
        blog: "Blog & Actualités",
        faq: "FAQ",
        gallery: "Galerie",
        traiteur: "Traiteur",
        marketingSettings: "Réglages Marketing",
        integrations: "Intégrations",
        loyaltyReport: "Rapport Fidélité",
        referralReport: "Rapport Parrainage",
        giftCards: "Cartes Cadeaux",
    },
    omnesightAi: {
        title: "Omnesight AI",
        subtitle: "Configurez votre intégration et synchronisez vos données.",
        config: "Configuration",
        apiKey: "Clé API Omnesight",
        apiKeyPlaceholder: "Entrez votre clé API...",
        saveConfig: "Enregistrer la configuration",
        historyPush: "Historique des commandes",
        pushDescription: "Envoyez l'historique complet de vos commandes localement vers l'IA Omnesight pour analyse.",
        pushButton: "Pousser l'historique",
        pushConfirm: "Êtes-vous sûr de vouloir pousser l'historique pour cette période ? Cela peut prendre quelques minutes.",
        pushSuccess: "Importation terminée : {imported} commandes synchronisées sur un total de {total}.",
        startDate: "Date de début",
        endDate: "Date de fin",
        periodSelection: "Sélection de la période",
        limit3Months: "La période ne peut pas dépasser 3 mois",
        limit1000Orders: "Volume trop important ({count} commandes). Veuillez réduire la période.",
        selectPeriod: "Veuillez sélectionner une période",
        dateError: "La date de début doit être antérieure à la date de fin",
        lastSync: "Dernière synchronisation",
        never: "Jamais",
        status: "Statut",
        active: "Activé",
        inactive: "Désactivé",
        selectRestaurant: "Sélectionner un restaurant",
        allRestaurants: "Tous les restaurants",
        testConnection: "Tester la connexion",
    },
    integrations: {
        title: "Intégrations Marketplaces",
        subtitle: "Synchronisez vos commandes Uber Eats et Just Eat avec votre système Va Bene.",
        uberEats: "Uber Eats (Suisse)",
        justEat: "Just Eat Suisse",
        delegateDelivery: "Déléguer la livraison à la plateforme",
        delegateDeliveryHelp: "Si activé, Uber/JustEat gère ses propres chauffeurs par défaut.",
        activation: "Activer l'intégration",
        storeId: "Store ID (UUID)",
        clientId: "Client ID",
        clientSecret: "Client Secret",
        apiKey: "Clé API (Token)",
        saveSuccess: "Configuration {platform} mise à jour avec succès",
        testSuccess: "Connexion réussie avec {platform}",
        testError: "Erreur lors du test de l'intégration {platform}",
    },
    order: {
        orders: "Commande(s)",
        removed: "Retiré(s)",
        noOrders: "Aucune commande trouvée.",
        orderDetails: "Détails de la commande",
        createDate: "Créer le:",
        pickupDate: "Date de recuperation:",
        paymentMethod: "Méthode de paiement:",
        orderType: "Type de commande:",
        notSpecified: "Non spécifiée",
        immediately: "TOUT DE SUITE",
        customer: "Client",
        customerInfo: "Information du Client",
        deliveryAddress: "Adresse de livraison",
        orderItems: "Articles de commande",
        productList: "Liste des produits",
        subtotal: "Sous-total",
        deliveryFee: "Frais de livraison",
        discount: "Remise",
        tax: "Taxe",
        grandTotal: "Total général",
        orderStatus: "Statut de la commande",
        notes: "Notes",
        invoice: "Facture & Parrainage",
        invoiceNumber: "Facture:",
        coupon: "Coupon:",
        civility: "Civilité:",
        customerType: "Type de client:",
        company: "Entreprise",
        classic: "Classique",
        fullName: "Nom & Prénom:",
        email: "E-mail:",
        phoneNumber: "Numéro de téléphone",
        quantity: "Quantité",
        total: "Total",
        ingredients: "Ingrédients",
        supplements: "Suppléments",
        noSupplements: "Aucun supplément",
        supplementName: "NOM DU SUPPLÉMENT",
        ingredientName: "NOM DE L'INGREDIENT",
        type: "TYPE",
        price: "PRIX",
        description: "DESCRIPTION",
        orderNote: "Note de la commande",
        orderId: "Commande ID-",
        estimatedDeliveryTime: "Délai de livraison estimé",
        customerInstruction: "Instruction du client",
        orderSummary: "Récapitulatif de la commande",
        includingVat: "Y COMPRIS TVA (2.60%)",
        includingVatDynamic: "Y COMPRIS TVA ({rate}%)",
        additionalFees: "FRAIS SUPPLÉMENTAIRES",
        noIngredients: "Aucun Ingrédient",
        unknownProduct: "Produit inconnu",
        noCategory: "Sans catégorie",
        yes: "Oui",
        no: "Non",
        free: "Gratuit",
        paid: "Payant",
        shouldSlice: "Doit-on trancher",
        paymentAddress: "Adresse de facturation",
        street: "Rue",
        number: "Nº",
        postalCode: "NPA",
        locality: "Localité",
        phone: "Téléphone",
        totalGross: "TOTAL BRUT",
        vat: "2.60% TVA",
        productName: "NOM DU PRODUIT",
        productPrice: "PRIX DU PRODUIT",
        paymentStatus: "Status de paiement",
        paymentMethodTitle: "Méthode de paiement",
        paymentMethods: {
            payClickCollectCash: "Paiement en espèces",
            payClickCollectCarte: "Paiement par carte",
            payDeliveryCash: "Paiement en espèces à la livraison",
            payDeliveryCarte: "Paiement par carte à la livraison",
            online: "Paiement en ligne (Walle)",
        },
        orderTypes: {
            delivery: "A Livrer",
            clickCollect: "A emporter",
            dineIn: "À emporter (physique)",
        },
        status: {
            pending: "En attente",
            processing: "En cours de traitement",
            readyForDelivery: "Prêt pour livraison",
            outForDelivery: "En cours de livraison",
            delivered: "Livré",
            cancelled: "Annulé",
        },
        preOrder: "PRÉCOMMANDE",
        rightAway: "TOUT DE SUITE",
        products: "produits",
        netTotal: "Total net",
        viewDetails: "Voir détail",
        viewPdf: "Consulter le PDF",
        noOrdersAvailable: "Aucune commande disponible.",
        unknown: "Inconnu",
        transactionReference: "Référence de transaction",
        pdf: "PDF",
    },
    product: {
        addProduct: "Ajouter un produit",
        editProduct: "Modifier le produit",
        productName: "Nom du produit",
        productDescription: "Description du produit",
        productPrice: "Prix du produit",
        productCategory: "Catégorie du produit",
        productImage: "Image du produit",
        nutritionalValues: "Notes & valeurs nutritionnelles",
        multilingualTranslations: "Traductions multilingues",
        complete: "Complété",
        incomplete: "Incomplet",
        giveNote: "Donnez une note et valeur nutritionnelle",
        type: "Type",
        category: "Catégorie",
        restaurant: "Restaurant",
        positioning: "Positionnement",
        image: "Image",
        uploadFile: "Upload fichier",
        httpsLink: "Lien HTTPS",
        acceptedFormats: "Formats acceptés: JPEG, PNG, WebP (max 2 Mo)",
        enterValidHttpsUrl: "Entrez une URL HTTPS valide vers une image",
        productVariation: "Variation du produit (Specifier les différentes tailles)",
        updateVariation: "Mettre a jour variation",
        addVariation: "Ajouter une variation",
        sizes: "taille(s)",
        noSize: "Aucune taille",
        specifyProductSizes: "Specifier les différentes taille du produit",
        size: "Taille",
        takeawayPrice: "Prix Emporter",
        deliveryPriceLabel: "Prix de Livraison",
        specificSizeDescription: "Description specifique a cette taille",
        add: "Ajouter",
        validate: "Valider",
        remove: "Retirer",
        noSizeAdded: "Aucune taille ajouter pour le moment",
        SIZE: "TAILLE",
        TAKEAWAY_PRICE: "PRIX EMPORTER",
        DELIVERY_PRICE: "PRIX DE LIVRAISON",
        DESCRIPTION: "DESCRIPTION",
        ACTIONS: "ACTIONS",
        addTurkeyBreast: "Ajouter pointrine de Dinde",
        addHam: "Ajouter Jambon",
        addPowderedSugar: "Ajouter sucre glace",
        addSauces: "Ajouter sauces",
        addCheese: "Ajouter fromage",
        removeAllOptions: "Supprimer toutes les options",
        chooseAppropriateRestaurant: "Choisissez le restaurant approprié",
        restaurantNotMatchCategory: "Le restaurant sélectionné ne correspond pas à celui de la catégorie du produit. Veuillez choisir le restaurant approprié.",
        baseIngredients: "Ingrédients de base",
        updateIngredients: "Mettre à jour ingrédients",
        addBaseIngredients: "Ajouter des ingrédients de base",
        noIngredientSelected: "Aucun ingrédient sélectionné",
        searchBaseIngredient: "Rechercher un ingrédient de base",
        selectedIngredients: "Ingrédients sélectionnés",
        noIngredientFound: "Aucun ingrédient trouvé pour",
        selectPizzaBaseIngredients: "Sélectionner les ingrédients de base de la pizza",
        baseSupplements: "Suppléments de base",
        updateSupplements: "Mettre à jour suppléments",
        addBaseSupplements: "Ajouter des suppléments de base",
        noSupplementSelected: "Aucun supplément sélectionné",
        searchSupplement: "Rechercher un supplément",
        selectedSupplements: "Suppléments sélectionnés",
        noSupplementFound: "Aucun supplément trouvé pour",
        selectBaseSupplements: "Sélectionner les suppléments de base",
        notesInLanguage: "Notes en",
        update: "Mettre à jour",
        categoryResetWarning: "La catégorie a été réinitialisée car elle ne correspond pas au restaurant sélectionné.",
        invalidUrlMessage: "URL invalide. Veuillez entrer une URL valide (ex: https://exemple.com/image.jpg)",
        categoryNotBelongRestaurant: "Cette catégorie n'appartient pas au restaurant sélectionné. Veuillez choisir une catégorie appropriée.",
        displaySettings: "Paramètres d'affichage",
        isCustomizable: "Produit personnalisable (Ingrédients/Suppléments)",
        showSizes: "Afficher le sélecteur de taille",
        visibility: "Visibilité du produit",
        showOnWeb: "Afficher sur le Web",
        showOnApp: "Afficher sur l'Application Mobile",
        promotionBanner: "Bannière promotionnelle",
        bannerText: "Texte de la bannière",
        bannerColor: "Couleur de la bannière",
        bannerActive: "Activer la bannière",
        bannerDuration: "Durée de la bannière",
        startDate: "Date de début",
        endDate: "Date de fin",
        personalizationCategories: "Catégories de personnalisation",
        maxAdditions: "Max ajouts",
        ingredientCategories: "Catégories d'ingrédients",
        manageIngredientCategories: "Gérer les catégories d'ingrédients",
        noIngredientCategorySelected: "Aucune catégorie sélectionnée",
    },
    category: {
        addCategory: "Ajouter une catégorie",
        editCategory: "Modifier la catégorie",
        categoryName: "Nom de la catégorie",
        categoryDescription: "Description de la catégorie",
        categoryImage: "Image de la catégorie",
        multilingualTranslations: "Traductions multilingues",
        complete: "Complété",
        incomplete: "Incomplet",
    },
    ingredient: {
        addIngredient: "Ajouter un ingrédient",
        editIngredient: "Modifier l'ingrédient",
        ingredientName: "Nom de l'ingrédient",
        ingredientDescription: "Description de l'ingrédient",
        ingredientPrice: "Prix de l'ingrédient",
        ingredientImage: "Image de l'ingrédient",
        ingredientPosition: "Position",
        ingredientPositionPlaceholder: "e.g. 1, 2, 3...",
        ingredientPositionHelp: "Position de l'ingrédient dans la liste (optionnel)",
        multilingualTranslations: "Traductions multilingues",
        complete: "Complété",
        incomplete: "Incomplet",
        manageTypes: "Gérer les types",
        manageTypePositions: "Gérer les positions des types d'ingrédients",
        noTypesAvailable: "Aucun type d'ingrédient disponible",
        noIngredientTypesAvailable: "Aucun type d'ingrédient disponible",
        addIngredientType: "Ajouter un type d'ingrédient",
        editIngredientType: "Modifier un type d'ingrédient",
        code: "Code",
        label: "Libellé",
        typeCreated: "Type d'ingrédient créé avec succès",
        typeUpdated: "Type d'ingrédient mis à jour avec succès",
        typeDeleted: "Type d'ingrédient supprimé avec succès",
        errorLoadingTypes: "Erreur lors du chargement des types d'ingrédients",
        errorSavingType: "Erreur lors de la sauvegarde du type d'ingrédient",
        errorDeletingType: "Erreur lors de la suppression du type d'ingrédient",
        errorUpdatingPosition: "Erreur lors de la mise à jour de la position",
        deleteTypeConfirmation: "Confirmation de suppression",
        deleteTypeConfirmationText: "Êtes-vous sûr de vouloir supprimer ce type d'ingrédient ?<br />Cette action est irréversible. Les ingrédients associés à ce type auront leur type défini sur NULL.",
        codeHelp: "Le code doit être unique (ex: POISSON, FROMAGE, etc.)",
        positionHelp: "Position d'affichage (optionnel, minimum 1)",
        translations: "Traductions",
        notDefined: "Non défini",
        manageTranslations: "Gérer les traductions",
        translationUpdated: "Traduction mise à jour avec succès",
        errorUpdatingTranslation: "Erreur lors de la mise à jour de la traduction",
        noIngredients: "Aucun ingrédient pour le moment",
        type: "Type",
        position: "Position",
        deleteConfirmation: "Confirmation de suppression",
        deleteConfirmationText: "Êtes-vous sûr de vouloir supprimer cet ingrédient ?<br />Cette action est irréversible.",
        invalidPosition: "Veuillez entrer une position valide (minimum 1)",
        positionUpdated: "Position mise à jour avec succès",
        paginationInfo: "Affichage de {start} à {end} sur {total} résultats",
        namePlaceholder: "e.g. Poivre",
        managePositions: "Gérer les positions",
        selectType: "Sélectionnez un type",
        typePlaceholder: "Type de l'ingrédient en {lang}",
        namePlaceholderLang: "Nom de l'ingrédient en {lang}",
        icon: "Icone",
        imageUrlPlaceholder: "Coller l'URL de l'image (ex: https://...)",
        variationLabel: "Variation de l'ingrédient (Spécifier les différentes tailles)",
        updateVariation: "Mettre à jour variation",
        addVariation: "Ajouter une variation",
        size: "Taille",
        noSizeAdded: "Aucune taille ajoutée pour le moment",
        noSizeAddedModal: "Aucune taille ajoutée pour le moment",
        specifySizes: "Spécifier les différentes tailles de l'ingrédient",
        sizePlaceholder: "Grande",
        pricePlaceholder: "12.90",
        remove: "Retirer",
        addVariationRequired: "Ajoutez au moins une variation (taille/prix) pour l'ingrédient",
    },
    supplement: {
        addSupplement: "Ajouter un supplément",
        editSupplement: "Modifier le supplément",
        supplementName: "Nom du supplément",
        supplementDescription: "Description du supplément",
        supplementPrice: "Prix du supplément",
        supplementImage: "Image du supplément",
        supplementPosition: "Position",
        supplementPositionPlaceholder: "e.g. 1, 2, 3...",
        supplementPositionHelp: "Position du supplément dans la liste (optionnel)",
        multilingualTranslations: "Traductions multilingues",
        complete: "Complété",
        incomplete: "Incomplet",
        manageTypes: "Gérer les types",
        manageTypePositions: "Gérer les positions des types de suppléments",
        noTypesAvailable: "Aucun type de supplément disponible",
        noSupplementTypesAvailable: "Aucun type de supplément disponible",
        addSupplementType: "Ajouter un type de supplément",
        editSupplementType: "Modifier un type de supplément",
        code: "Code",
        label: "Libellé",
        typeCreated: "Type de supplément créé avec succès",
        typeUpdated: "Type de supplément mis à jour avec succès",
        typeDeleted: "Type de supplément supprimé avec succès",
        errorLoadingTypes: "Erreur lors du chargement des types de suppléments",
        errorSavingType: "Erreur lors de la sauvegarde du type de supplément",
        errorDeletingType: "Erreur lors de la suppression du type de supplément",
        errorUpdatingPosition: "Erreur lors de la mise à jour de la position",
        deleteTypeConfirmation: "Confirmation de suppression",
        deleteTypeConfirmationText: "Êtes-vous sûr de vouloir supprimer ce type de supplément ?<br />Cette action est irréversible. Les suppléments associés à ce type auront leur type défini sur NULL.",
        codeHelp: "Le code doit être unique (ex: SAUCE, FROMAGE, etc.)",
        positionHelp: "Position d'affichage (optionnel, minimum 1)",
        translations: "Traductions",
        notDefined: "Non défini",
        manageTranslations: "Gérer les traductions",
        translationUpdated: "Traduction mise à jour avec succès",
        errorUpdatingTranslation: "Erreur lors de la mise à jour de la traduction",
        noSupplements: "Aucun supplément pour le moment",
        type: "Type",
        position: "Position",
        deleteConfirmation: "Confirmation de suppression",
        deleteConfirmationText: "Êtes-vous sûr de vouloir supprimer ce supplément ?<br />Cette action est irréversible.",
        invalidPosition: "Veuillez entrer une position valide (minimum 1)",
        positionUpdated: "Position mise à jour avec succès",
        paginationInfo: "Affichage de {start} à {end} sur {total} résultats",
        namePlaceholder: "e.g. Sauce piquante",
        managePositions: "Gérer les positions",
        selectType: "Sélectionnez un type",
        typePlaceholder: "Type du supplément en {lang}",
        namePlaceholderLang: "Nom du supplément en {lang}",
        icon: "Icone",
        imageUrlPlaceholder: "URL de l'image du supplément",
        variationLabel: "Variations de prix",
        updateVariation: "Modifier les variations",
        addVariation: "Ajouter les variations",
        size: "Taille",
        noSizeAdded: "Aucune taille ajoutée pour le moment",
        noSizeAddedModal: "Aucune taille ajoutée pour le moment",
        specifySizes: "Spécifier les différentes tailles du supplément",
        sizePlaceholder: "Grande",
        pricePlaceholder: "2.50",
        remove: "Retirer",
        addVariationRequired: "Ajoutez au moins une variation (taille/prix) pour le supplément",
    },
    feature: {
        addFeature: "Ajouter une option",
        editFeature: "Modifier la option",
        featureName: "Nom de la option",
        featureDescription: "Description de la option",
        featurePrice: "Prix de la option",
        featureImage: "Image de la option",
        featurePosition: "Position",
        featurePositionPlaceholder: "e.g. 1, 2, 3...",
        featurePositionHelp: "Position de la option dans la liste (optionnel)",
        multilingualTranslations: "Traductions multilingues",
        complete: "Complété",
        incomplete: "Incomplet",
        translations: "Traductions",
        notDefined: "Non défini",
        manageTranslations: "Gérer les traductions",
        translationUpdated: "Traduction mise à jour avec succès",
        errorUpdatingTranslation: "Erreur lors de la mise à jour de la traduction",
        noFeatures: "Aucune option pour le moment",
        position: "Position",
        deleteConfirmation: "Confirmation de suppression",
        deleteConfirmationText: "Êtes-vous sûr de vouloir supprimer cette option ?<br />Cette action est irréversible.",
        invalidPosition: "Veuillez entrer une position valide (minimum 1)",
        positionUpdated: "Position mise à jour avec succès",
        paginationInfo: "Affichage de {start} à {end} sur {total} résultats",
        namePlaceholder: "e.g. Nouvelle fonctionnalité",
        managePositions: "Gérer les positions",
        namePlaceholderLang: "Nom de la option en {lang}",
        icon: "Icone",
        imageUrlPlaceholder: "URL de l'image de la option",
        variationLabel: "Variations de prix",
        updateVariation: "Modifier les variations",
        addVariation: "Ajouter les variations",
        size: "Taille",
        noSizeAdded: "Aucune taille ajoutée pour le moment",
        noSizeAddedModal: "Aucune taille ajoutée pour le moment",
        specifySizes: "Spécifier les différentes tailles de la option",
        sizePlaceholder: "Grande",
        pricePlaceholder: "2.50",
        remove: "Retirer",
        addVariationRequired: "Ajoutez au moins une variation (taille/prix) pour la option",
        features: "Options",
    },
    auth: {
        login: "Connexion",
        loginButton: "Se connecter",
        register: "Inscription",
        registerButton: "S'inscrire",
        createAccount: "Créer votre compte",
        forgotPassword: "Mot de passe oublié?",
        forgotPasswordText: "Entrez votre adresse e-mail ci-dessous et nous vous enverrons le mot de passe récupéré",
        resetPassword: "Réinitialiser le mot de passe",
        email: "E-mail",
        emailAddress: "Adresse e-mail",
        password: "Mot de passe",
        confirmPassword: "Confirmer le mot de passe",
        firstName: "Prénom",
        lastName: "Nom",
        name: "Nom",
        rememberMe: "Se souvenir",
        backToSignIn: "Retour à la connexion",
        alreadyHaveAccount: "Vous avez déjà un compte?",
        dontHaveAccount: "Vous n'avez pas de compte?",
        logInNow: "Se connecter maintenant",
        registerNow: "S'inscrire maintenant",
        acceptTerms: "J'accepte tous les",
        termsAndConditions: "Termes et conditions",
        submit: "Soumettre",
        invalidCredentials: "Nom utilisateur ou mot de passe invalide",
        missingToken: "Token d'authentification manquant",
    },
    validation: {
        required: "Ce champ est requis",
        email: "Veuillez entrer un e-mail valide",
        minLength: "Ce champ doit contenir au moins {min} caractères",
        maxLength: "Ce champ ne peut pas dépasser {max} caractères",
        passwordMismatch: "Les mots de passe ne correspondent pas",
    },
    messages: {
        success: {
            saved: "Enregistré avec succès",
            deleted: "Supprimé avec succès",
            updated: "Mis à jour avec succès",
            paymentMethodUpdated: "Méthode de paiement mise à jour avec succès",
            paymentMethodActivated: "Moyen de paiement activé avec succès",
            paymentMethodDeactivated: "Moyen de paiement désactivé avec succès",
            paymentMethodAdded: "Moyen de paiement ajouté avec succès",
            userDeleted: "Utilisateur supprimé avec succès",
            userStatusUpdated: "Statut de l'utilisateur mis à jour avec succès",
            postalCodeAdded: "Code postal ajouté avec succès",
            postalCodeRemoved: "Code postal {code} supprimé",
            variationsUpdated: "Variations mises à jour avec succès",
            imageSelected: "Image sélectionnée avec succès",
            openingHoursDeleted: "Horaires supprimés avec succès",
            userAddedToCampaign: "Utilisateur ajouté à la campagne",
            couponRemoved: "Coupon supprimé",
            newOrderReceived: "Nouvelle commande reçue !",
            newOrderInRestaurant: "Nouvelle commande dans un restaurant",
            ingredientAdded: "Ingrédient ajouté avec succès",
            ingredientRemoved: "Ingrédient retiré avec succès",
            baseIngredientsValidated: "Ingrédients de base validés",
            supplementAdded: "Supplément ajouté avec succès",
            supplementRemoved: "Supplément retiré avec succès",
            baseSupplementsValidated: "Suppléments de base validés",
            printTicketSuccess: "🎉 Ticket imprimé avec succès",
            timeSlotDeleted: "Créneau supprimé avec succès",
            timeSlotActivated: "Créneau activé avec succès",
            timeSlotDeactivated: "Créneau désactivé avec succès",
        },
        error: {
            generic: "Une erreur s'est produite",
            loadFailed: "Erreur lors du chargement",
            network: "Erreur de connexion",
            unauthorized: "Non autorisé",
            notFound: "Ressource non trouvée",
            invalidPaymentMethod: "Méthode de paiement invalide",
            paymentMethodUpdateFailed: "Erreur lors de la mise à jour de la méthode de paiement",
            loadPaymentMethodsFailed: "Erreur lors du chargement des moyens de paiement",
            updateFailed: "Erreur lors de la mise à jour",
            statusUpdateFailed: "Erreur lors de la mise à jour du statut",
            paymentStatusUpdateFailed: "Erreur lors de la mise à jour du statut de paiement",
            deleteUserFailed: "Erreur lors de la suppression de l'utilisateur",
            updateUserStatusFailed: "Erreur lors de la modification du statut de l'utilisateur",
            loadUsersFailed: "Erreur lors du chargement des utilisateurs",
            restaurantIdNotFound: "ID du restaurant non trouvé",
            loadDeliveryZoneFailed: "Erreur lors du chargement de la zone",
            loadCategoriesFailed: "Erreur lors du chargement des catégories",
            loadRestaurantsFailed: "Erreur lors du chargement des restaurants",
            loadOrdersFailed: "Erreur lors du chargement des commandes",
            loadCampaignsFailed: "Erreur lors du chargement des campagnes",
            loadProductsFailed: "Erreur lors du chargement des produits",
            loadIngredientsFailed: "Erreur lors du chargement des ingrédients",
            loadSupplementsFailed: "Erreur lors du chargement des suppléments",
            loadIngredientBasesFailed: "Erreur lors du chargement des ingrédients de base",
            loadOpeningHoursFailed: "Erreur lors du chargement des horaires",
            loadDeliveryZonesFailed: "Erreur lors du chargement des zones de livraison",
            loadTimeSlotsFailed: "Erreur lors du chargement des créneaux",
            loadCouponsFailed: "Erreur lors du chargement des coupons",
            loadFranchisesFailed: "Erreur lors du chargement des franchises",
            loadOperationsFailed: "Erreur lors du chargement des opérations",
            loadDataFailed: "Erreur lors du chargement des données",
            loadPostalCodesFailed: "Erreur lors du chargement des codes postaux",
            loadOrderTypesFailed: "Erreur lors du chargement des types de commandes",
            loadCustomerInfoFailed: "Erreur lors du chargement des informations clients",
            loadTimeSlotFailed: "Erreur lors du chargement du créneau",
            fileTypeNotAllowed: "Type de fichier non autorisé",
            fileTooLarge: "Fichier trop volumineux",
            invalidQuantity: "Quantité invalide",
            restaurantInfoMissing: "Informations du restaurant manquantes",
            fillAllFields: "Veuillez remplir tous les champs",
            couponAlreadyApplied: "Ce coupon est déjà appliqué",
            enterPromoCode: "Veuillez entrer un code promo",
            invalidPromoCode: "Code promo invalide",
            imageUploadFailed: "Erreur lors de l'upload de l'image",
            selectValidImageFile: "Veuillez sélectionner un fichier image valide",
            fileSizeExceeded: "La taille du fichier ne doit pas dépasser 5MB",
            deletionFailed: "Erreur lors de la suppression",
            invalidPrice: "Le prix doit être un nombre valide",
            ingredientBaseNameRequired: "Le nom de l'ingrédient de base est requis",
            deleteTimeSlotFailed: "Erreur lors de la suppression du créneau",
            deleteOrderFailed: "Erreur lors de la suppression de la commande",
            deleteVariationFailed: "Erreur lors de la suppression de la variation",
            deleteProductFailed: "Erreur lors de la suppression du produit",
            deletePostalCodeFailed: "Erreur lors de la suppression du code postal",
            deleteZoneFailed: "Erreur lors de la suppression de la zone",
            updateStatusFailed: "Erreur lors de la mise à jour du statut",
            updateZoneFailed: "Erreur lors de la mise à jour de la zone",
            updateStelaStatusFailed: "Erreur lors de la mise à jour du statut stela",
            updateFeaturedStatusFailed: "Erreur lors de la mise en vedette du produit",
            selectRestaurant: "Veuillez sélectionner un restaurant",
            saveTimeSlotFailed: "Erreur lors de l'enregistrement du créneau",
            saveOpeningHoursFailed: "Erreur lors de l'enregistrement des horaires",
            generatePdfFailed: "Erreur lors de la génération du PDF",
            printTicketFailed: "Erreur lors de l'impression du ticket",
            loadExistingIngredientsFailed: "Erreur lors du chargement des ingrédients existants",
            fillRequiredFields: "Veuillez remplir tous les champs obligatoires",
            restaurantNotSelected: "Restaurant non sélectionné",
            provideImageOrUrl: "Veuillez fournir une image (fichier ou URL)",
            urlMustStartWithHttps: "L'URL doit commencer par https://",
            ingredientAlreadyAdded: "Cet ingrédient est déjà ajouté",
            supplementAlreadyAdded: "Ce supplément est déjà ajouté",
            loadExistingSupplementsFailed: "Erreur lors du chargement des suppléments existants",
            invalidProductId: "ID de produit invalide",
            missingCategoryId: "ID de catégorie manquant",
            editFeatureToImplement: "Fonctionnalité d'édition à implémenter",
            loadUserAddressesFailed: "Erreur lors du chargement des adresses utilisateur",
            loadRestaurantInfoFailed: "Erreur lors du chargement des informations du restaurant",
            loadRestaurantDetailsFailed: "Erreur lors du chargement des détails du restaurant",
            reloadDataFailed: "Erreur lors du rechargement des données",
            loadProductFailed: "Erreur lors du chargement du produit",
            saveFeatureFailed: "Erreur lors de la sauvegarde de la option",
            loadFeatureFailed: "Erreur lors du chargement de la option",
            loadFeaturesFailed: "Erreur lors du chargement des options",
            updateFeatureFailed: "Erreur lors de la mise à jour de la option",
        },
        warning: {
            userAlreadyInList: "Cet utilisateur est déjà dans la liste",
            selectUser: "Veuillez sélectionner un utilisateur",
        },
    },
    reports: {
        ordersByStatus: {
            title: "Commandes par statut",
            subtitle: "Filtrez par période et statut, puis consultez le nombre et le montant.",
            columns: {
                status: "Statut",
                count: "Nombre",
                amount: "Montant",
            },
            empty: "Aucune donnée pour cette période.",
        },
        averageBasket: {
            title: "Panier moyen",
            subtitle: "Filtrez par période, type de commande, méthode de paiement et statut.",
            valueLabel: "Panier moyen",
            columns: {
                count: "Nombre",
                totalAmount: "Montant",
                averageBasket: "Panier moyen",
            },
            empty: "Aucune donnée pour cette période.",
        },
    },
    lists: {
        allStatus: "Tous",
        deleted: "Supprimé",
        add: "Ajouter",
        search: "Rechercher",
        searchProduct: "Rechercher un produit",
        searchOrder: "Rechercher une commande",
        filterByCategory: "Filtrer par categorie",
        selectRestaurant: "Sélectionner un restaurant",
        restaurant: "Restaurant",
        id: "ID",
        name: "NOM",
        category: "CATEGORIE",
        status: "STATUS",
        notificationStatus: {
            draft: "Brouillon",
            sent: "Envoyé",
        },
        createdAt: "CRÉÉ LE",
        featured: "VEDETTE",
        size: "TAILLE",
        ref: "REF",
        type: "TYPE",
        client: "CLIENT",
        amount: "MONTANT",
        orderStatus: "COMMANDE STATUS",
        paymentStatus: "PAIEMENT STATUS",
        phoneNumber: "NUMÉRO TÉLÉPHONE",
        actions: "ACTIONS",
        cancel: "Annuler",
        delete: "Supprimer",
        confirmDelete: "Êtes-vous sûr de vouloir supprimer ce produit ?",
        confirmDeleteText: "Cette action est irréversible.",
        takeaway: "À emporter",
        dineIn: "À emporter (physique)",
        delivery: "À livrer",
        pending: "En attente",
        confirmed: "Confirmée",
        preparing: "En préparation",
        ready: "Prête",
        delivered: "Livrée",
        cancelled: "Annulée",
        processing: "En cours de traitement",
        readyForDelivery: "Prêt pour livraison",
        delivering: "En cours de livraison",
        awaitingPayment: "En attente de paiement",
        paid: "Payé",
        refunded: "A remboursé",
        paymentCancelled: "Annulé",
        icon: "ICONE",
        availability: "DISPONIBILITÉ",
        extraPrice: "PRIX SUPPLÉMENTAIRE",
        searchCustomer: "Rechercher un client",
        searchUser: "Rechercher un utilisateur",
        clearSearch: "Effacer la recherche",
        fullName: "NOM COMPLET",
        email: "E-MAIL",
        phone: "TÉLÉPHONE",
        accountType: "TYPE DE COMPTE",
        verification: "VÉRIFICATION",
        addUser: "Ajouter un utilisateur",
        userDetails: "Détails utilisateur",
        editHeadRestaurant: "Modifier le responsable du restaurant",
        addRestaurant: "Ajouter un restaurant",
        uploadMenu: "Télécharger le menu",
        selectPdfFile: "Sélectionner un fichier PDF",
        maxFileSize: "Taille maximale",
        acceptedFormat: "Format accepté",
        selectedFile: "Fichier sélectionné",
        uploading: "Upload en cours...",
        upload: "Uploader",
        addTimeSlot: "Ajouter un créneau",
        addDeliveryZone: "Ajouter une zone de livraison",
        searchRestaurant: "Rechercher un restaurant",
        searchTimeSlot: "Rechercher un créneau",
        searchZone: "Rechercher une zone",
        restaurantName: "NOM DU RESTAURANT",
        managerName: "NOM & PRÉNOM DU RESPONSABLE",
        zoneAndAddress: "ZONE & ADRESSE",
        zoneName: "NOM DE LA ZONE",
        minimumAmount: "MONTANT MINIMUM",
        deliveryFee: "FRAIS DE LIVRAISON",
        freeDeliveryThreshold: "SEUIL LIVRAISON GRATUITE",
        postalCodes: "CODES POSTAUX",
        confirmDeleteTimeSlot: "Êtes-vous sûr de vouloir supprimer ce créneau ?",
        confirmDeleteRestaurant: "Êtes-vous sûr de vouloir supprimer ce restaurant ?",
        confirmDeleteDeliveryZone: "Êtes-vous sûr de vouloir supprimer cette zone de livraison ?",
        addCampaign: "Ajouter une campagne",
        searchCampaign: "Rechercher une campagne",
        confirmDeleteCampaign: "Êtes-vous sûr de vouloir supprimer cette campagne ?",
        campaignId: "ID",
        campaignTitle: "TITRE",
        campaignMessage: "MESSAGE",
        campaignStatus: "STATUS",
        campaignRecipients: "DESTINATAIRES",
        campaignCreatedAt: "CRÉÉ LE",
        recipient: "destinataire",
        recipients: "destinataire(s)",
        selectedRecipients: "destinataire(s) sélectionné(s)",
        view: "Voir",
        send: "Envoyer",
        verified: "Verifié",
        unverified: "Non-verifié",
        noCustomers: "Aucun client pour le moment",
        noUsers: "Aucun utilisateur pour le moment",
        confirmDeleteUser: "Confirmation de suppression",
        confirmDeleteUserText: "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
        confirmDeleteUserAction: "Cette action est irréversible.",
        noCampaigns: "Aucune campagne pour le moment",
        displayResults: "Affichage de {start} à {end} sur {total} résultats",
        pickupDelay: "Délai à emporter",
        deliveryDelay: "Délai livraison",
        noTimeSlots: "Aucun créneau pour le moment",
        confirmDeleteTitle: "Confirmation de suppression",
        campaignStatuses: {
            sent: "Envoyé",
            pending: "En attente",
            draft: "Brouillon",
            scheduled: "Programmé",
        },
        campaignTypes: {
            individual: "Individuel",
            group: "Groupé",
        },
        allRestaurants: "Tous les restaurants",
        addToCampaign: "Ajouter à la campagne",
        removeRecipient: "Supprimer ce destinataire",
        usersAddedAutomatically: "{count} utilisateurs ajoutés automatiquement",
        addCoupon: "Ajouter un coupon",
        searchCoupon: "Rechercher un coupon",
        confirmDeleteCoupon: "Êtes-vous sûr de vouloir supprimer ce coupon ?",
        manageOpeningHours: "Gérez les horaires d'ouverture de votre restaurant",
        addOpeningHours: "Ajouter des horaires",
        noOpeningHours: "Aucun horaire configuré",
        startConfigureOpeningHours: "Commencez par configurer les horaires d'ouverture de votre restaurant.",
        configureOpeningHours: "Configurer les horaires",
        managePaymentMethods: "Gérez les moyens de paiement de votre restaurant",
        addPaymentMethod: "Ajouter un moyen de paiement",
        paymentMethod: "Moyen de paiement",
        noPaymentMethods: "Aucun moyen de paiement configuré",
        startConfigurePaymentMethods: "Commencez par configurer les moyens de paiement de votre restaurant.",
        configurePaymentMethods: "Configurer les moyens de paiement",
        enabled: "Activé",
        disabled: "Désactivé",
        selectPaymentMethod: "Sélectionner un moyen de paiement",
        enablePaymentMethod: "Activer le moyen de paiement",
        selectRestaurantFirst: "Veuillez d'abord sélectionner un restaurant",
        day: "Jour",
        hours: "Horaires",
        break: "Pause",
        closed: "Fermé",
        searchTransaction: "Rechercher une transaction",
        transactionId: "TRANSACTION ID",
        orderId: "COMMANDE ID",
        confirmDeleteTransaction: "Êtes-vous sûr de vouloir supprimer cette transaction ?",
        addIngredientBase: "Ajouter un ingrédient de base",
        searchIngredientBase: "Rechercher un ingrédient de base",
        addNotification: "Ajouter une notification",
        searchNotification: "Rechercher une notification",
        confirmDeleteNotification: "Êtes-vous sûr de vouloir supprimer cette notification ?",
        searchProgram: "Rechercher un programme",
        programName: "NOM DU PROGRAMME",
        rewardEarned: "GAIN OBTENU",
        confirmDeleteProgram: "Êtes-vous sûr de vouloir supprimer ce programme ?",
        noPrograms: "Aucun programme pour le moment",
        referral: "PARRAINAGE",
        loyalty: "FIDÉLITÉ",
        addFranchise: "Ajouter une franchise",
        searchFranchise: "Rechercher une franchise",
        confirmDeleteFranchise: "Êtes-vous sûr de vouloir supprimer cette franchise ?",
        title: "TITLE",
        message: "MESSAGE",
        edit: "Editer",
        confirmDeleteFranchiseText: "Êtes-vous sûr de vouloir supprimer cette franchise ?",
        show: "Afficher",
        platform: "PLATEFORME",
        translations: "Traductions",
    },
    forms: {
        restaurantImage: "Bannière d'image du restaurant",
        website: "Site Web",
        enablePosWalkthrough: "Activer le guide interactif du POS",
        posWalkthroughDescription: "Si activé, le personnel du restaurant verra une visite guidée lors de la première utilisation du POS.",
        sendingType: "Type d'envoi",
        notificationType: "Type de notification",
        targetChoice: "Choix de la cible",
        recipients: "Destinataires",
        example: "e.g.",
        passwordPlaceholder: "**************",
        phoneNumber: "Numéro téléphone",
        country: "Pays",
        switzerland: "Suisse",
        france: "France",
        germany: "Allemagne",
        italy: "Italie",
        unitedKingdom: "Royaume-Uni",
        unitedStates: "États-Unis",
        belgium: "Belgique",
        austria: "Autriche",
        selectRestaurantPlaceholder: "Sélectionner un restaurant",
        selectTypePlaceholder: "Sélectionner un type",
        selectCategoryPlaceholder: "Sélectionner une catégorie",
        searchCategoryPlaceholder: "Rechercher une catégorie",
        chooseFile: "Choisir un fichier",
        imageUrlPlaceholder: "https://exemple.com/image.jpg",
        searchIngredientPlaceholder: "Tapez pour rechercher un ingrédient...",
        searchSupplementPlaceholder: "Tapez pour rechercher un supplément...",
        searchFeaturePlaceholder: "Tapez pour rechercher une option...",
        sizePlaceholder: "Grande",
        sizeDescriptionPlaceholder: "Donnez une description pour cette taille",
        categoryDescriptionPlaceholder: "Donnez une description a la categorie",
        online: "En ligne",
        atDelivery: "A la livraison",
        powderedSugar: "Sucre glace",
        addParmesan: "Ajouter parmesan",
        addSauces: "Ajouter sauces",
        customize: "Personnaliser",
        ham: "Jambon",
        turkeyBreast: "Pointrine de Dinde",
        italianSauce: "Sauce Italienne",
        postalCode: "Code postal",
        selectPostalCode: "Sélectionner le code postal",
        city: "Localité",
        selectCity: "Sélectionner la ville",
        street: "Rue",
        role: "Rôle",
        selectRole: "Sélectionner un rôle",
        technicalSupport: "SUPPORT TECHNIQUE",
        oldPassword: "Ancien mot de passe",
        newPassword: "Nouveau mot de passe",
        restaurantName: "Nom du Restaurant",
        managerFirstName: "Prenom du responsable",
        managerLastName: "Nom du responsable",
        vatNumber: "Numéro TVA",
        vatRate: "Taux de TVA (%)",
        address: "Adresse",
        additionalAddress: "Informations complémentaires",
        streetNumber: "Numero de rue",
        zoneName: "Nom de la zone",
        minimumAmount: "Montant minimum (CHF)",
        deliveryFee: "Frais de livraison (CHF)",
        deliveryFeePlaceholder: "e.g. 5.00 (laisser vide pour gratuit)",
        freeDeliveryThreshold: "Seuil de livraison gratuite (CHF)",
        freeDeliveryThresholdPlaceholder: "e.g. 30.00 (laisser vide pour aucun seuil)",
        description: "Description",
        zoneDescription: "Description de la zone",
        postalCodes: "Codes postaux",
        postalCodePlaceholder: "Code postal",
        locality: "Localité",
        add: "Ajouter",
        postalCodesAdded: "code(s) postal(aux) ajouté(s)",
        noPostalCodes: "Aucun code postal ajouté. Vous pouvez en ajouter après la création de la zone.",
        removePostalCode: "Supprimer ce code postal",
        postalCodeLocalityAlreadyAdded: "Cette combinaison code postal et localité a déjà été ajoutée",
        fillAllFields: "Veuillez remplir tous les champs",
        createZone: "Créer la zone",
        updateZone: "Mettre à jour",
        pickupDelay: "Délai à emporter (minutes)",
        pickupDelayPlaceholder: "Ex: 20",
        pickupDelayHelp: "Temps d'attente pour les commandes à emporter",
        deliveryDelay: "Délai livraison (minutes)",
        deliveryDelayPlaceholder: "Ex: 45",
        deliveryDelayHelp: "Temps d'attente pour les commandes en livraison",
        slotInterval: "Intervalle entre créneaux (minutes)",
        slotIntervalPlaceholder: "Ex: 15",
        slotIntervalHelp: "Intervalle entre chaque créneau disponible",
        maxCapacity: "Capacité maximale",
        maxCapacityPlaceholder: "Ex: 1",
        maxCapacityHelp: "Nombre maximum de commandes par créneau",
        startTime: "Heure de début",
        startTimeHelp: "Heure de début des créneaux",
        endTime: "Heure de fin",
        endTimeHelp: "Heure de fin des créneaux",
        activateConfig: "Activer cette configuration",
        timeSlotExample: "Exemple : Si un client commande à 12h00 pour la livraison, la prochaine précommande disponible sera à 12h45 (12h00 + 45 minutes).",
        editTimeSlot: "Modifier le créneau",
        addTimeSlot: "Ajouter un créneau",
        configureDelays: "Configurez les délais pour les commandes à emporter et en livraison",
        updateTimeSlot: "Mettre à jour",
        title: "Titre",
        titlePlaceholder: "e.g. Nouveauté",
        campaignDescription: "Description de la campagne",
        selectRestaurant: "Sélectionner un restaurant",
        type: "Type",
        typeLabel: "Type",
        selectType: "Sélectionner le type",
        selectClient: "Sélectionner un client",
        clientsAdded: "client(s) ajouté(s)",
        selectDateTime: "Sélectionner une date et heure",
        couponCode: "Code du coupon",
        couponCodePlaceholder: "e.g. 5",
        value: "Valeur",
        limit: "Limite",
        limitPlaceholder: "e.g. 10",
        noUserFound: "Aucun utilisateur trouvé",
        franchiseName: "Nom de la franchise",
        franchiseDescription: "Description de la franchise",
        franchiseDescriptionPlaceholder: "Décrivez la franchise et ses activités (spécialité, date de création, etc...)",
        image: "Image",
        uploadImage: "Télécharger une image",
        imagePreview: "Aperçu de l'image",
        removeImage: "Supprimer l'image",
        changeImage: "Changer l'image",
        selectImage: "Sélectionner une image",
        imageSizeWarning: "La taille de l'image ne doit pas dépasser 1 Mo.",
        programName: "Nom du programme",
        programDescription: "Description du programme",
        programDescriptionPlaceholder: "Donnez une description au programme",
        gain: "Gain",
        gainPlaceholder: "e.g. Pizza",
        openingHoursTitle: "Horaires d'ouverture",
        manageOpeningHours: "Gérez les horaires d'ouverture de votre restaurant",
        addAddress: "Ajouter une adresse",
        noAddressSaved: "Aucune adresse enregistrée.",
        page: "Page",
        noOrders: "Aucune commande.",
        show: "Afficher",
        transactionReference: "Référence transaction",
        pdf: "PDF",
        civility: "Civilité",
        lastName: "Nom",
        firstName: "Prénom",
        email: "E-mail",
        phone: "Téléphone",
        dateOfBirth: "Date de naissance",
        companyName: "Nom de l'entreprise",
        companyAddress: "Adresse de l'entreprise",
        companyVat: "TVA de l'entreprise",
        companyPhone: "Téléphone de l'entreprise",
        companyEmail: "E-mail de l'entreprise",
        customerInfo: "Information du client",
        useCustomerGenericInfo: "Utiliser les informations du client",
        quantityUtensils: "Quantité de couverts",
        orderDate: "Date",
        orderTime: "Heure",
        whenOrderDesired: "Quand souhaiteriez-vous votre commande ?",
        dateAndTimeDesired: "Date et heure souhaitées",
        immediately: "Immédiatement",
        whatToPayAttention: "À quoi devons-nous faire attention ?",
        orderInstructions: "Instructions de commande",
        productName: "Nom du produit",
        quantity: "Quantité",
        price: "Prix",
        totalAmount: "Montant total",
        ingredient: "Ingrédient",
        addIngredient: "Ajouter un ingrédient",
        noProductInCart: "Aucun produit ajouté au panier pour le moment",
        availableIn: "Existe en",
        size: "taille",
        choose: "Choisir",
        cart: "Panier",
        generalInfo: "Information générale",
        chooseSize: "Choisissez la taille",
        selectAdditionalIngredients: "Sélectionner les ingrédients supplémentaires",
        selectIngredient: "Sélectionner un ingrédient",
        averageAmount: "Montant moyen",
        product: "Produit",
        startDate: "Début",
        endDate: "Fin",
        start: "Début",
        end: "Fin",
        category: "Catégorie",
        orderType: "Type de commande",
        selectOrderType: "Sélectionner un type de commande",
        salesThisWeek: "VENTES CETTE SEMAINE",
        totalOrders: "Total des commandes",
        totalSales: "Total des ventes",
        totalCustomers: "Total des clients",
        totalProducts: "Total des produits",
        totalCategories: "Total des catégories",
        totalIngredients: "Total des ingrédients",
        totalTimeSlots: "Total des créneaux",
        totalDeliveryZones: "Total des zones de livraison",
        totalUsers: "Total des utilisateurs",
        totalRestaurants: "Total des restaurants",
        totalFranchises: "Total des franchises",
        totalCoupons: "Total des coupons",
        totalCampaigns: "Total des campagnes",
        totalNotifications: "Total des notifications",
        totalPrograms: "Total des programmes",
        totalIngredientBases: "Total des ingrédients de base",
        totalOpeningHours: "Total des horaires d'ouverture",
        totalTransactions: "Total des transactions",
        totalCustomersThisMonth: "Total des clients ce mois-ci",
        totalOrdersThisMonth: "Total des commandes ce mois-ci",
        totalSalesThisMonth: "Total des ventes ce mois-ci",
        totalProductsThisMonth: "Total des produits ce mois-ci",
        totalCategoriesThisMonth: "Total des catégories ce mois-ci",
        totalIngredientsThisMonth: "Total des ingrédients ce mois-ci",
        totalTimeSlotsThisMonth: "Total des créneaux ce mois-ci",
        totalDeliveryZonesThisMonth: "Total des zones de livraison ce mois-ci",
        totalUsersThisMonth: "Total des utilisateurs ce mois-ci",
        totalRestaurantsThisMonth: "Total des restaurants ce mois-ci",
        totalFranchisesThisMonth: "Total des franchises ce mois-ci",
        totalCouponsThisMonth: "Total des coupons ce mois-ci",
        totalCampaignsThisMonth: "Total des campagnes ce mois-ci",
        totalNotificationsThisMonth: "Total des notifications ce mois-ci",
        totalProgramsThisMonth: "Total des programmes ce mois-ci",
        totalIngredientBasesThisMonth: "Total des ingrédients de base ce mois-ci",
        totalOpeningHoursThisMonth: "Total des horaires d'ouverture ce mois-ci",
        totalTransactionsThisMonth: "Total des transactions ce mois-ci",
        totalCustomersLastMonth: "Total des clients le mois dernier",
        totalOrdersLastMonth: "Total des commandes le mois dernier",
        totalSalesLastMonth: "Total des ventes le mois dernier",
        totalProductsLastMonth: "Total des produits le mois dernier",
        totalCategoriesLastMonth: "Total des catégories le mois dernier",
        totalIngredientsLastMonth: "Total des ingrédients le mois dernier",
        totalTimeSlotsLastMonth: "Total des créneaux le mois dernier",
        totalDeliveryZonesLastMonth: "Total des zones de livraison le mois dernier",
        totalUsersLastMonth: "Total des utilisateurs le mois dernier",
        totalRestaurantsLastMonth: "Total des restaurants le mois dernier",
        totalFranchisesLastMonth: "Total des franchises le mois dernier",
        totalCouponsLastMonth: "Total des coupons le mois dernier",
        totalCampaignsLastMonth: "Total des campagnes le mois dernier",
        totalNotificationsLastMonth: "Total des notifications le mois dernier",
        totalProgramsLastMonth: "Total des programmes le mois dernier",
        totalIngredientBasesLastMonth: "Total des ingrédients de base le mois dernier",
        totalOpeningHoursLastMonth: "Total des horaires d'ouverture le mois dernier",
        totalTransactionsLastMonth: "Total des transactions le mois dernier",
        totalCustomersLastYear: "Total des clients l'année dernière",
        totalOrdersLastYear: "Total des commandes l'année dernière",
        totalSalesLastYear: "Total des ventes l'année dernière",
        totalProductsLastYear: "Total des produits l'année dernière",
        totalCategoriesLastYear: "Total des catégories l'année dernière",
        totalIngredientsLastYear: "Total des ingrédients l'année dernière",
        totalTimeSlotsLastYear: "Total des créneaux l'année dernière",
        totalDeliveryZonesLastYear: "Total des zones de livraison l'année dernière",
        totalUsersLastYear: "Total des utilisateurs l'année dernière",
        totalRestaurantsLastYear: "Total des restaurants l'année dernière",
        totalFranchisesLastYear: "Total des franchises l'année dernière",
        totalCouponsLastYear: "Total des coupons l'année dernière",
        totalCampaignsLastYear: "Total des campagnes l'année dernière",
        totalNotificationsLastYear: "Total des notifications l'année dernière",
        totalProgramsLastYear: "Total des programmes l'année dernière",
        totalIngredientBasesLastYear: "Total des ingrédients de base l'année dernière",
        totalOpeningHoursLastYear: "Total des horaires d'ouverture l'année dernière",
        totalTransactionsLastYear: "Total des transactions l'année dernière",
        totalCustomersAllTime: "Total des clients de tous les temps",
        totalOrdersAllTime: "Total des commandes de tous les temps",
        totalSalesAllTime: "Total des ventes de tous les temps",
        totalProductsAllTime: "Total des produits de tous les temps",
        totalCategoriesAllTime: "Total des catégories de tous les temps",
        totalIngredientsAllTime: "Total des ingrédients de tous les temps",
        totalTimeSlotsAllTime: "Total des créneaux de tous les temps",
        totalDeliveryZonesAllTime: "Total des zones de livraison de tous les temps",
        totalUsersAllTime: "Total des utilisateurs de tous les temps",
        totalRestaurantsAllTime: "Total des restaurants de tous les temps",
        totalFranchisesAllTime: "Total des franchises de tous les temps",
        totalCouponsAllTime: "Total des coupons de tous les temps",
        totalCampaignsAllTime: "Total des campagnes de tous les temps",
        totalNotificationsAllTime: "Total des notifications de tous les temps",
        totalProgramsAllTime: "Total des programmes de tous les temps",
        totalIngredientBasesAllTime: "Total des ingrédients de base de tous les temps",
        totalOpeningHoursAllTime: "Total des horaires d'ouverture de tous les temps",
        totalTransactionsAllTime: "Total des transactions de tous les temps",
        totalCustomersToday: "Total des clients aujourd'hui",
        totalOrdersToday: "Total des commandes aujourd'hui",
        totalSalesToday: "Total des ventes aujourd'hui",
        totalProductsToday: "Total des produits aujourd'hui",
        totalCategoriesToday: "Total des catégories aujourd'hui",
        totalIngredientsToday: "Total des ingrédients aujourd'hui",
        totalTimeSlotsToday: "Total des créneaux aujourd'hui",
        totalDeliveryZonesToday: "Total des zones de livraison aujourd'hui",
        totalUsersToday: "Total des utilisateurs aujourd'hui",
        totalRestaurantsToday: "Total des restaurants aujourd'hui",
        totalFranchisesToday: "Total des franchises aujourd'hui",
        totalCouponsToday: "Total des coupons aujourd'hui",
        totalCampaignsToday: "Total des campagnes aujourd'hui",
        totalNotificationsToday: "Total des notifications aujourd'hui",
        totalProgramsToday: "Total des programmes aujourd'hui",
        totalIngredientBasesToday: "Total des ingrédients de base aujourd'hui",
        totalOpeningHoursToday: "Total des horaires d'ouverture aujourd'hui",
        totalTransactionsToday: "Total des transactions aujourd'hui",
        totalCustomersYesterday: "Total des clients hier",
        totalOrdersYesterday: "Total des commandes hier",
        totalSalesYesterday: "Total des ventes hier",
        totalProductsYesterday: "Total des produits hier",
        totalCategoriesYesterday: "Total des catégories hier",
        totalIngredientsYesterday: "Total des ingrédients hier",
        totalTimeSlotsYesterday: "Total des créneaux hier",
        totalDeliveryZonesYesterday: "Total des zones de livraison hier",
        totalUsersYesterday: "Total des utilisateurs hier",
        totalRestaurantsYesterday: "Total des restaurants hier",
        totalFranchisesYesterday: "Total des franchises hier",
        totalCouponsYesterday: "Total des coupons hier",
        totalCampaignsYesterday: "Total des campagnes hier",
        totalNotificationsYesterday: "Total des notifications hier",
        totalProgramsYesterday: "Total des programmes hier",
        totalIngredientBasesYesterday: "Total des ingrédients de base hier",
        totalOpeningHoursYesterday: "Total des horaires d'ouverture hier",
        totalTransactionsYesterday: "Total des transactions hier",
        totalCustomersLast7Days: "Total des clients des 7 derniers jours",
        totalOrdersLast7Days: "Total des commandes des 7 derniers jours",
        totalSalesLast7Days: "Total des ventes des 7 derniers jours",
        totalProductsLast7Days: "Total des produits des 7 derniers jours",
        totalCategoriesLast7Days: "Total des catégories des 7 derniers jours",
        totalIngredientsLast7Days: "Total des ingrédients des 7 derniers jours",
        totalTimeSlotsLast7Days: "Total des créneaux des 7 derniers jours",
        totalDeliveryZonesLast7Days: "Total des zones de livraison des 7 derniers jours",
        totalUsersLast7Days: "Total des utilisateurs des 7 derniers jours",
        totalRestaurantsLast7Days: "Total des restaurants des 7 derniers jours",
        totalFranchisesLast7Days: "Total des franchises des 7 derniers jours",
        totalCouponsLast7Days: "Total des coupons des 7 derniers jours",
        totalCampaignsLast7Days: "Total des campagnes des 7 derniers jours",
        totalNotificationsLast7Days: "Total des notifications des 7 derniers jours",
        totalProgramsLast7Days: "Total des programmes des 7 derniers jours",
        totalIngredientBasesLast7Days: "Total des ingrédients de base des 7 derniers jours",
        totalOpeningHoursLast7Days: "Total des horaires d'ouverture des 7 derniers jours",
        totalTransactionsLast7Days: "Total des transactions des 7 derniers jours",
        totalCustomersLast30Days: "Total des clients des 30 derniers jours",
        totalOrdersLast30Days: "Total des commandes des 30 derniers jours",
        totalSalesLast30Days: "Total des ventes des 30 derniers jours",
        totalProductsLast30Days: "Total des produits des 30 derniers jours",
        totalCategoriesLast30Days: "Total des catégories des 30 derniers jours",
        totalIngredientsLast30Days: "Total des ingrédients des 30 derniers jours",
        totalTimeSlotsLast30Days: "Total des créneaux des 30 derniers jours",
        totalDeliveryZonesLast30Days: "Total des zones de livraison des 30 derniers jours",
        totalUsersLast30Days: "Total des utilisateurs des 30 derniers jours",
        totalRestaurantsLast30Days: "Total des restaurants des 30 derniers jours",
        totalFranchisesLast30Days: "Total des franchises des 30 derniers jours",
        totalCouponsLast30Days: "Total des coupons des 30 derniers jours",
        totalCampaignsLast30Days: "Total des campagnes des 30 derniers jours",
        totalNotificationsLast30Days: "Total des notifications des 30 derniers jours",
        totalProgramsLast30Days: "Total des programmes des 30 derniers jours",
        totalIngredientBasesLast30Days: "Total des ingrédients de base des 30 derniers jours",
        totalOpeningHoursLast30Days: "Total des horaires d'ouverture des 30 derniers jours",
        totalTransactionsLast30Days: "Total des transactions des 30 derniers jours",
        totalCustomersLast90Days: "Total des clients des 90 derniers jours",
        totalOrdersLast90Days: "Total des commandes des 90 derniers jours",
        totalSalesLast90Days: "Total des ventes des 90 derniers jours",
        totalProductsLast90Days: "Total des produits des 90 derniers jours",
        totalCategoriesLast90Days: "Total des catégories des 90 derniers jours",
        totalIngredientsLast90Days: "Total des ingrédients des 90 derniers jours",
        totalTimeSlotsLast90Days: "Total des créneaux des 90 derniers jours",
        totalDeliveryZonesLast90Days: "Total des zones de livraison des 90 derniers jours",
        totalUsersLast90Days: "Total des utilisateurs des 90 derniers jours",
        totalRestaurantsLast90Days: "Total des restaurants des 90 derniers jours",
        totalFranchisesLast90Days: "Total des franchises des 90 derniers jours",
        totalCouponsLast90Days: "Total des coupons des 90 derniers jours",
        totalCampaignsLast90Days: "Total des campagnes des 90 derniers jours",
        totalNotificationsLast90Days: "Total des notifications des 90 derniers jours",
        totalProgramsLast90Days: "Total des programmes des 90 derniers jours",
        totalIngredientBasesLast90Days: "Total des ingrédients de base des 90 derniers jours",
        totalOpeningHoursLast90Days: "Total des horaires d'ouverture des 90 derniers jours",
        totalTransactionsLast90Days: "Total des transactions des 90 derniers jours",
        totalCustomersLast365Days: "Total des clients des 365 derniers jours",
        totalOrdersLast365Days: "Total des commandes des 365 derniers jours",
        totalSalesLast365Days: "Total des ventes des 365 derniers jours",
        totalProductsLast365Days: "Total des produits des 365 derniers jours",
        totalCategoriesLast365Days: "Total des catégories des 365 derniers jours",
        totalIngredientsLast365Days: "Total des ingrédients des 365 derniers jours",
        totalTimeSlotsLast365Days: "Total des créneaux des 365 derniers jours",
        totalDeliveryZonesLast365Days: "Total des zones de livraison des 365 derniers jours",
        totalUsersLast365Days: "Total des utilisateurs des 365 derniers jours",
        totalRestaurantsLast365Days: "Total des restaurants des 365 derniers jours",
        totalFranchisesLast365Days: "Total des franchises des 365 derniers jours",
        totalCouponsLast365Days: "Total des coupons des 365 derniers jours",
        totalCampaignsLast365Days: "Total des campagnes des 365 derniers jours",
        totalNotificationsLast365Days: "Total des notifications des 365 derniers jours",
        totalProgramsLast365Days: "Total des programmes des 365 derniers jours",
        totalIngredientBasesLast365Days: "Total des ingrédients de base des 365 derniers jours",
        totalOpeningHoursLast365Days: "Total des horaires d'ouverture des 365 derniers jours",
        totalTransactionsLast365Days: "Total des transactions des 365 derniers jours",
        totalCustomersLastWeek: "Total des clients la semaine dernière",
        totalOrdersLastWeek: "Total des commandes la semaine dernière",
        totalSalesLastWeek: "Total des ventes la semaine dernière",
        totalProductsLastWeek: "Total des produits la semaine dernière",
        totalCategoriesLastWeek: "Total des catégories la semaine dernière",
        totalIngredientsLastWeek: "Total des ingrédients la semaine dernière",
        totalTimeSlotsLastWeek: "Total des créneaux la semaine dernière",
        totalDeliveryZonesLastWeek: "Total des zones de livraison la semaine dernière",
        totalUsersLastWeek: "Total des utilisateurs la semaine dernière",
        totalRestaurantsLastWeek: "Total des restaurants la semaine dernière",
        totalFranchisesLastWeek: "Total des franchises la semaine dernière",
        totalCouponsLastWeek: "Total des coupons la semaine dernière",
        totalCampaignsLastWeek: "Total des campagnes la semaine dernière",
        totalNotificationsLastWeek: "Total des notifications la semaine dernière",
        totalProgramsLastWeek: "Total des programmes la semaine dernière",
        totalIngredientBasesLastWeek: "Total des ingrédients de base la semaine dernière",
        totalOpeningHoursLastWeek: "Total des horaires d'ouverture la semaine dernière",
        totalTransactionsLastWeek: "Total des transactions la semaine dernière",
        filterByRestaurant: "Filtre par restaurant",
        amountOrdersByCategory: "MONTANT DE COMMANDES PAR (CATEGORIE)",
        amountOrdersByProduct: "MONTANT DE COMMANDES PAR (PRODUIT)",
        allTypes: "Tous les types",
        allMethods: "Toutes les méthodes",
        orders: "commande(s)",
        Orders: "Commande(s)",
        averageQuantityPerOrder: "QUANTITÉ MOYENNE D'UN PRODUIT PAR COMMANDE",
        errorLoadingCategories: "Erreur lors du chargement des catégories",
        errorLoadingProducts: "Erreur lors du chargement des produits",
        errorLoadingData: "Erreur lors du chargement des données",
        errorLoadingRestaurant: "Erreur lors du chargement des restaurants",
        errorLoadingAverage: "Erreur lors de la récupération de average",
        errorLoadingAverageRate: "Erreur lors du chargement du taux moyens",
        pleaseSelectRestaurant: "Veuillez sélectionner un restaurant spécifique pour consulter les données.",
        pleaseSelectRestaurantRefresh: "Veuillez sélectionner un restaurant pour rafraîchir les données.",
        noProductDataForPeriod: "Aucune donnée produit pour cette période",
        noCategoryDataForPeriod: "Aucune donnée catégorie pour cette période",
        allowOrderModification: "Autoriser la modification des commandes",
        allowOrderDeletion: "Autoriser la suppression des commandes",
        allowOrderAcceptation: "Autoriser l'acceptation des commandes",
        showGoogleMapsQr: "Afficher QR Code Google Maps sur tickets",
        showGoogleMapsQrHelp: "Indique si le QR code Google Maps doit être affiché sur les tickets",
    },
    ingredientBase: {
        addIngredientBase: "Ajouter un ingrédient de base",
        editIngredientBase: "Modifier l'ingrédient de base",
        ingredientBaseName: "Nom de l'ingrédient de base",
        ingredientBaseNameHelp: "Saisissez le nom de l'ingrédient de base pour les pizzas",
        ingredientBasePosition: "Position",
        ingredientBasePositionPlaceholder: "e.g. 1, 2, 3...",
        ingredientBasePositionHelp: "Position de l'ingrédient de base dans la liste (optionnel)",
    },
    pos: {
        closureSummary: "Récapitulatif de fermeture",
        searchMenuPlaceholder: "Rechercher dans le menu...",
        divers: "Article Divers",
        customPrice: "Prix libre",
        dailyClosure: "Clôture de journée",
        closeDay: "Clôturer la journée",
        addCustomItem: "Ajouter un article divers",
        itemAdded: "Article ajouté au panier",
        closureConfirmed: "Clôture confirmée et email envoyé.",
        theoreticalTotal: "Total Théorique",
        actualTotal: "Total Réel",
        gap: "Écart de caisse",
        reportSentFranchise: "Un rapport a été envoyé par email à la franchise.",
        confirmClosure: "Confirmer la clôture",
        closureInstruction: "Veuillez saisir les montants réels comptés dans votre caisse pour aujourd'hui.",
        noCategoriesFound: "Aucune catégorie trouvée",
        errorLoadingCategories: "Erreur lors du chargement des catégories",
        noActiveProductsFound: "Aucun produit actif trouvé pour cette catégorie",
        errorLoadingProducts: "Erreur lors du chargement des produits",
        ingredientsLoadedSuccess: "Ingrédients chargés avec succès",
        errorLoadingIngredients: "Erreur lors du chargement des ingrédients",
        additionalOptions: "Options additionnelles",
        selectOneOption: "Veuillez sélectionner une option",
        customizeProduct: "Personnaliser votre produit",
        includedIngredientsInfo: "Les ingrédients marqués \"Inclus\" viennent avec la pizza",
        addModeDescription: "Mode Ajouter : ajoutez des ingrédients supplémentaires",
        removeModeDescription: "Mode Retirer : retirez même les ingrédients inclus",
        included: "Inclus",
        free: "Gratuit",
        unknownIngredient: "Ingrédient inconnu",
        addToCart: "Ajouter au panier",
        add: "Ajouter",
        customize: "Personnaliser",
        customizeIngredients: "Personnaliser les ingrédients",
        remove: "Retirer",
        addSpecialInstructions: "Ajouter des instructions spéciales pour votre commande...",
        customizeSalad: "Personnaliser la salade",
        customizePasta: "Personnaliser les pâtes",
        customizeOptions: "Personnaliser les options",
        customizeYour: "Personnaliser vos",
        chooseOption: "Choisissez une option",
        selectedOption: "Option sélectionnée",
        addParmesanDescription: "Ajoutez du parmesan râpé pour encore plus de saveur (1.00 CHF) :",
        createCustomPizza: "Créer votre pizza personnalisée",
        searchIngredient: "Rechercher un ingrédient...",
        pizzaSummary: "Résumé de votre pizza",
        sizeLabel: "Taille",
        noIngredientsSelected: "Aucun ingrédient sélectionné",
        chooseSize: "Choisir la taille",
        glutenFree: "Sans gluten",
        deliveryPrice: "Prix de Livraison",
        noProductsFound: "Aucun produit trouvé",
        tryChangeSearchOrCategory: "Essayez de changer votre recherche ou la catégorie sélectionnée.",
        addSaucesForSalad: "Ajoutez des sauces pour sublimer votre salade.",
        chooseYourSauces: "Choisissez vos sauces",
        cart: "Panier",
        generalInfo: "Information générale",
        noProductInCart: "Aucun produit ajouter au panier pour le moment",
        availableIn: "Existe en",
        size: "taille",
        choose: "Choisir",
        orderInstructions: "Instructions de commande",
        selectOrderType: "Selectionner type de commande",
        whenOrder: "Quand souhaiteriez-vous votre commande ?",
        whatToPayAttention: "À quoi devons-nous faire attention ?",
        orderNotes: "Notes de commande",
        requestUtensils: "Demande de couverts",
        utensilsQuantity: "Quantité de couverts",
        useCustomerInfo: "Utiliser les informattions du client",
        cookingType: {
            normal: "Normal",
            rare: "Saignant",
            medium: "À point",
            wellDone: "Bien cuit",
        },
        schedule: {
            morningOpening: "Ouverture matin",
            lunchBreak: "Pause déjeuner",
            afternoonOpening: "Ouverture après-midi",
        },
        customerInfo: "Informations Client",
        registeredCustomerSelected: "Client enregistré sélectionné",
        deselect: "Désélectionner",
        firstName: "Prénom",
        firstNamePlaceholder: "Prénom du client",
        lastName: "Nom",
        lastNamePlaceholder: "Nom du client",
        phone: "Téléphone",
        phonePlaceholder: "Numéro de téléphone",
        email: "E-mail",
        emailPlaceholder: "E-mail du client",
        invalidEmail: "Veuillez saisir une adresse e-mail valide",
        orderType: "Type de commande",
        orderTypeDineIn: "À emporter (physique)",
        orderTypeClickCollect: "À emporter",
        orderTypeDelivery: "Livraison",
        clientType: "Type client",
        clientTypeCustomer: "Client",
        clientTypeOrganisation: "Organisation",
        company: "Société",
        companyPlaceholder: "Nom de la société",
        department: "Département",
        departmentPlaceholder: "Département",
        pickupTime: "Moment de récupération",
        pickupTimeHour: "Heure de récupération",
        asSoonAsPossible: "Dès que possible",
        restaurantClosed: "(Restaurant fermé)",
        readyInMinutes: "Prêt dans 15-20 minutes",
        scheduledDateTime: "Date et heure souhaitées",
        scheduleForLater: "Programmer pour plus tard",
        pickupDate: "Date de récupération",
        selectDate: "Sélectionner une date",
        selectTime: "Sélectionner une heure",
        noTimeAvailableToday: "Aucune heure disponible aujourd'hui. Veuillez sélectionner demain.",
        deliveryAddress: "Adresse de livraison",
        savedAddresses: "Adresses enregistrées",
        newAddress: "Nouvelle adresse",
        postalCode: "NPA (Code postal)",
        postalCodePlaceholder: "Code postal",
        locality: "Localité",
        localityPlaceholder: "Localité",
        street: "Rue",
        streetPlaceholder: "Nom de la rue",
        streetNumber: "N° Rue",
        streetNumberPlaceholder: "Numéro de rue",
        order: "Commande",
        items: "article(s)",
        emptyCart: "Panier vide",
        addItemsToStart: "Ajoutez des articles pour commencer",
        summary: "Résumé",
        promoCode: "Code promo",
        enterPromoCode: "Entrez votre code promo",
        apply: "Appliquer",
        couponRemoved: "Coupon supprimé",
        minimumOrderAmount: "Montant minimum de commande :",
        supplementApplied: "(supplément de {amount} CHF appliqué)",
        disableMinOrder: "Désactiver le montant minimum",
        enableMinOrder: "Réactiver le montant minimum",
        discountType: "Type de rabais",
        percentage: "Pourcentage (%)",
        fixedAmount: "Montant fixe (CHF)",
        discount: "Rabais",
        discountPercentage: "Rabais (%)",
        discountFixed: "Rabais (CHF)",
        miscellaneous: "Divers (CHF)",
        miscellaneousLabel: "Divers",
        slice: "Trancher :",
        yes: "Oui",
        no: "Non",
        note: "Remarque",
        notePlaceholder: "Entrez votre remarque",
        subtotal: "Sous-total",
        discountLabel: "Rabais",
        coupon: "Coupon",
        customized: "Personnalisé:",
        removed: "Retiré:",
        options: "Options :",
        supplements: "Suppléments :",
        paymentMethod: "Mode de paiement",
        cashPayment: "Paiement en espèces",
        cardPayment: "Paiement par carte",
        minOrderSupplement: "Supplément minimum de commande",
        vat: "TVA ({rate}%)",
        total: "Total",
        validateOrder: "Valider la commande",
        processing: "Traitement...",
        orderCreatedSuccess: "Commande créée avec succès!",
        fillAllFields: "Veuiller remplir tous les champs!",
        restaurantInfoMissing: "Informations du restaurant manquantes",
        invalidPromoCode: "Code promo invalide",
        orderCreationError: "Erreur lors de la création de la commande",
        today: "Aujourd'hui",
        tomorrow: "Demain",
    },
    dashboard: {
        greeting: "Salut",
        whatHappeningToday: "Voici ce qui se passe dans vos restaurants aujourd'hui",
        whatHappeningTodaySingle: "Voici ce qui se passe dans votre restaurant aujourd'hui",
        salesThisWeek: "VENTES CETTE SEMAINE",
        salesThisWeekByRestaurant: "Ventes de la semaine en cours par restaurant",
        salesThisWeekLabel: "Ventes cette semaine",
        vsPreviousWeek: "vs semaine précédente:",
        previousWeek: "Semaine précédente",
        thisWeek: "Cette semaine",
        thisMonth: "Ce mois",
        thisYear: "Cette année",
        select: "Select",
        noDataAvailable: "Aucune donnée disponible pour le graphique",
        salesReportThisWeek: "RAPPORT DE VENTE CETTE SEMAINE",
        salesReportThisMonth: "RAPPORT DE VENTE CE MOIS-CI",
        salesReportThisYear: "RAPPORT DE VENTE CETTE ANNÉE",
        salesReportAllPeriods: "RAPPORT DE VENTE TOUTES PÉRIODES",
        salesReportPreviousWeek: "RAPPORT DE VENTE SEMAINE PRÉCÉDENTE",
    },
    pages: {
        editCustomer: "Modifier le client",
        addFranchise: "Ajouter une franchise",
        updateFranchise: "Mettre à jour la franchise",
        addProduct: "Ajouter un produit",
        updateProduct: "Mettre à jour produit",
        orderDetails: "Détail de la commande",
        openingHours: "Horaires d'ouverture",
        paymentMethods: "Moyens de paiement",
        generalInfo: "Information générale",
        addDeliveryZone: "Ajouter une zone de livraison",
        updateDeliveryZone: "Modifier la zone de livraison",
        customerList: "Liste des clients",
        addCustomer: "Ajouter un client",
        customerDetails: "Détail du client",
        ingredientList: "Liste des ingredients",
        ingredientTypeList: "Liste des types d'ingrédients",
        addIngredient: "Ajouter un ingredient",
        updateIngredient: "Mettre à jour ingredient",
        timeSlotList: "Liste des créneaux",
        addUser: "Ajouter un utilisateur",
        updateUserInfo: "Mettre a jour mes informations",
        userList: "Liste des utilisateurs",
        addCategory: "Ajouter une catégorie",
        updateCategory: "Mettre à jour la catégorie",
        categoryList: "Liste des categories",
        productList: "Liste des produits",
        createCoupon: "Créer un coupon",
        couponDetails: "Detail du coupon",
        couponList: "Liste des coupons",
        franchises: "Franchises",
        addProgram: "Ajouter un programme",
        updateProgram: "Mettre à jour le programme",
        referralLoyalty: "Parrainage & Fidelité",
        deliveryZoneList: "Zones de livraison",
        postalCodes: "Codes postaux",
        notificationList: "Liste des notifications",
        sendNotification: "Envoyer une notification",
        notificationDetails: "Détail de la notification",
        campaignList: "Liste des campagnes",
        addCampaign: "Ajouter une campagne",
        campaignDetails: "Detail campagne",
        restaurantList: "Liste des restaurants",
        addRestaurant: "Ajouter un restaurant",
        updateRestaurant: "Mettre a jour",
        ingredientBaseList: "Liste des ingrédients de base",
        transactionDetails: "Détail de la transaction",
        orders: "Commandes",
        transactions: "Transactions",
        configureOpeningHours: "Configuration des horaires",
        configureOpeningHoursSubtitle: "Définissez les jours d'ouverture et les horaires de votre restaurant",
        saveOpeningHours: "Enregistrer les horaires",
        optionalBreak: "Pause (optionnelle)",
        openingDays: "Jours d'ouverture",
        open: "Ouvert",
        partialOpen: "Partiellement ouvert",
        detailedHours: "Horaires détaillés",
        opening: "Ouverture",
        start: "Début",
        end: "Fin",
        break: "Pause",
        breakStart: "Début pause",
        breakEnd: "Fin pause",
        addHours: "Ajouter des horaires",
        addBreak: "Ajouter une pause",
        removeHours: "Supprimer les horaires",
        removeBreak: "Supprimer la pause",
        dayStatus: "Statut du jour",
        descriptionForDay: "Description pour {dayLabel}",
        daysOfWeek: {
            monday: "Lundi",
            tuesday: "Mardi",
            wednesday: "Mercredi",
            thursday: "Jeudi",
            friday: "Vendredi",
            saturday: "Samedi",
            sunday: "Dimanche",
        },
        resetPassword: "Reset Password",
        emailConfirmation: "E-mail Confirmation",
        forgotPassword: "Forgot Password",
        register: "Register",
        addTimeSlot: "Ajouter un créneau",
        updateTimeSlot: "Modifier le créneau",
        thisWeek: "Cette semaine",
        thisMonth: "Ce mois",
        thisYear: "Cette année",
        addTimeRange: "Ajouter une tranche horaire",
        timeRange: "Tranche horaire",
        deliverySlotConfig: "Configuration des créneaux de livraison",
        active: "Actif",
        inactive: "Inactif",
        selected: "Sélectionné",
        selectDayToConfigureHours: "Cliquez sur un jour ouvert pour configurer ses horaires détaillés",
        configureTimeRangesForDay: "Configurez les tranches horaires pour ce jour",
        noTimeRanges: "Aucune tranche horaire configurée",
        restaurantClosures: "Fermetures du restaurant",
    },
    customer: {
        averageBasket: "Panier moyen",
        orderChannelsBreakdown: "Répartition des canaux de commande",
        customerSpecification: "SPECIFICATION DU CLIENT",
        registeredAddressesList: "Liste des adresses enregistrées",
        remark: "Remarque",
        noRegisteredAddresses: "Aucune adresse enregistrée.",
        addAddress: "Ajouter une adresse",
        orderAnalysis: "Analyse lors des commandes",
        specificAttentionPoints: "Points d'attention spécifiques",
        enterAttentionPoints: "Entrez les points d'attention...",
        orderTypesHistory: "Historique des types de commandes",
        cutleryRequestDuringOrders: "Demande de couvert lors des commandes",
        clientPaymentHabits: "Habitudes de paiement du client",
        totalOrdersNumber: "Nombre total de commandes",
        orderHistoryTable: "Tableau d'historique de commandes",
        orderHistory: "Historique de commandes",
        primarilyOrdersType: "Le client passe principalement des commandes de type \"{type}\" ({count}/{total}).",
        varietyOrderTypes: "Le client présente une variété de types de commandes. Type dominant : \"{type}\" ({count}/{total}).",
        alwaysRequestsCutlery: "Le client demande systématiquement des couverts avec ses commandes.",
        neverRequestsCutlery: "Le client ne demande jamais de couverts.",
        majorityRequestsCutlery: "Le client demande les couverts de façon majoritaire.",
        rarelyRequestsCutlery: "Le client ne demande que rarement des couverts.",
        requestsCutleryAmount: "Le client demande {amount} couvert(s) lors de ses commandes.",
        exclusivelyUsesPaymentMethod: "Le client utilise exclusivement le mode de paiement \"{method}\".",
    },
    posClient: {
        title: "Client POS",
        description: "Ce client sera utilisé par défaut pour les commandes passées sur le POS si aucun client n'est sélectionné.",
        add: "Ajouter un client POS",
        edit: "Modifier le client POS",
        delete: "Supprimer le client POS",
        confirmDelete: "Êtes-vous sûr de vouloir supprimer ce client POS ?",
        saved: "Client POS enregistré avec succès",
        deleted: "Client POS supprimé avec succès",
        notFound: "Client POS non trouvé",
        firstName: "Prénom",
        lastName: "Nom",
        email: "E-mail (optionnel)",
        phone: "Téléphone",
        civility: "Civilité",
    },
    closures: {
        title: "Fermetures Exceptionnelles",
        addClosure: "Ajouter une fermeture",
        editClosure: "Modifier la fermeture",
        reason: "Motif",
        startDate: "Date de début",
        endDate: "Date de fin",
        isRecurring: "Récurrent (chaque année)",
        recurringHelp: "Si coché, la fermeture se répétera chaque année aux mêmes dates.",
        confirmDelete: "Êtes-vous sûr de vouloir supprimer cette fermeture ?",
        totalClosure: "Fermeture totale",
        restaurantSelection: "Sélection du restaurant",
        franchiseSelection: "Sélection de la franchise",
        allRestaurants: "Tous les restaurants",
        noReason: "Aucun motif spécifié",
    },
    loyalty: {
        totalReferralsInRange: "Total des parrainages dans cette période",
        reportTitle: "Journal des points fidélité",
        reportCustomer: "CLIENT",
        reportAction: "ACTION",
        reportPoints: "POINTS",
        reportBalance: "SOLDE",
        reportDate: "Date",
        reportLastActivity: "Dernière activité",
        earn: "Gagné",
        spend: "Dépensé",
        reverse: "Stourné",
        expired: "Expiré",
        adjustPoints: "Ajuster points",
        reverseTransaction: "Annuler la transaction",
        reverseSuccess: "Transaction annulée avec succès",
        adjustSuccess: "Points ajustés avec succès",
        reason: "Motif",
        amount: "Montant",
        confirmReverse: "Voulez-vous vraiment annuler cette transaction ?",
        confirmAdjust: "Voulez-vous vraiment ajuster les points de ce client ?",
        referralReport: "Rapport Parrainage",
        topReferrers: "Meilleurs Parrains",
        referrer: "Parrain",
        referee: "Filleul",
        referralDate: "Date d'invitation",
        pointsEarned: "Points obtenus",
        rewardStatus: "Statut récompense",
        rewarded: "Récompensé",
        pending: "En attente",
        searchReferral: "Rechercher un parrain ou filleul...",
        referralDetails: "Détails du parrainage",
        noReferrals: "Aucun parrainage trouvé sur cette période.",
        totalReferrals: "Total Parrainages",
        totalPoints: "Total Points"
    },
};
